import { render, staticRenderFns } from "./ScanCode.vue?vue&type=template&id=873fdcc4&scoped=true&"
import script from "./ScanCode.vue?vue&type=script&lang=js&"
export * from "./ScanCode.vue?vue&type=script&lang=js&"
import style0 from "./ScanCode.vue?vue&type=style&index=0&id=873fdcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873fdcc4",
  null
  
)

export default component.exports